import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "none",
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M32 7a1 1 0 0 1 .873.511l28 50A1 1 0 0 1 60 59H4a1 1 0 0 1-.873-1.489l28-50A1 1 0 0 1 32 7M5.706 57h52.588L32 10.047z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M32 24a1 1 0 0 1 1 1v16a1 1 0 1 1-2 0V25a1 1 0 0 1 1-1M32 47a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-3 1a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
		clipRule: "evenodd"
	})]
});
export default SvgWarning;
